import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__DismissableLayer_module_js_b989611c__ from "./DismissableLayer.module.js";
function DismissableLayer(props) {
    const { children, isVisible, onDismiss } = props;
    const handleDismiss = (event)=>{
        event.stopPropagation();
        onDismiss?.();
    };
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: __WEBPACK_EXTERNAL_MODULE__DismissableLayer_module_js_b989611c__["default"].DismissableLayer,
        "data-open": isVisible,
        onClick: handleDismiss,
        onKeyDown: handleDismiss,
        children: children
    });
}
export { DismissableLayer as default };

//# sourceMappingURL=DismissableLayer.js.map